<template>
  <b-card>
    <div>
      <div class="row">
        <b-form-group label="Location Type" label-for="location-type" class="col-lg-12">
          <b-select v-model="venue._type" id="location-type" name="location-type" v-validate="{ required: true }"
            :state="validateState('venue._type')">
            <option :value="null" selected>Select a Type</option>
            <option value="Amphitheater">Amphitheater</option>
            <option value="Arena">Arena</option>
            <option value="Cinema">Cinema</option>
            <option value="ConcertHall">Concert Hall</option>
            <option value="ConferenceCenter">Conference Center</option>
            <option value="ExhibitionHall">Exhibition Hall</option>
            <option value="FairGrounds">Fair Grounds</option>
            <option value="MusicHall">Music Hall</option>
            <option value="Racetrack">Racetrack</option>
            <option value="Stadium">Stadium</option>
            <option value="Theater">Theater</option>
          </b-select>
          <div class="red"><font-awesome-icon v-if="veeErrors.first('location-type')" icon="exclamation-circle" size="1x"
              style="color:red;" class=" mr-1 fas fa-exclamation-circle" />{{ veeErrors.first('location-type') }}</div>
        </b-form-group>
      </div>

      <div class="row">
        <TelephoneInput label="Telephone" id="phone" name="phone" v-model="venue.telephone" @input="dirty = true"
          @change="onChange" class="col-lg-3" />

        <!-- <b-form-group label="Telephone" label-for="telephone" class="col-lg-3">
          <b-form-input type="tel" id="telephone" name="telephone" v-mask="'(###) ###-####'" @input="dirty=true" v-model="venue.telephone" @change="onChange" />
        </b-form-group> -->

        <b-form-group label="Schedule URL" label-for="scheduleUrl" class="col-lg-3">
          <b-form-input type="url" id="scheduleUrl" name="scheduleUrl" v-model="venue.scheduleUrl" @change="onChange" />
          <b-form-invalid-feedback class="d-block red"
            v-if="this.venue.scheduleUrl && !urlTest.test(this.venue.scheduleUrl)">Must include http:// or
            https://</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Ticket URL" label-for="ticketUrl" class="col-lg-3">
          <b-form-input type="url" id="ticketUrl" name="ticketUrl" v-model="venue.ticketUrl" @change="onChange" />
          <b-form-invalid-feedback class="d-block red"
            v-if="this.venue.ticketUrl && !urlTest.test(this.venue.ticketUrl)">Must include http:// or
            https://</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Hours Of Operation" label-for="hoursOfOperation" class="col-lg-3">
          <b-form-input id="hours" name="hours" v-model="venue.hoursOfOperation" @change="onChange" />
        </b-form-group>
      </div>

      <div class="row mb-3">
        <div class="col-lg-12">
          <b-form-group label="Discounts" class="">
            <b-card>
              <b-form-checkbox-group id="discounts" name="Discounts" v-model="venue.discounts" @change="onChange"
                style="column-count: 2;" stacked>
                <b-form-checkbox value="AAA">AAA</b-form-checkbox>
                <b-form-checkbox value="Government">Government</b-form-checkbox>
                <b-form-checkbox value="Military">Military</b-form-checkbox>
                <b-form-checkbox value="Senior">Senior</b-form-checkbox>
              </b-form-checkbox-group>
            </b-card>
          </b-form-group>
        </div>
      </div>

      <b-form-group label="Credit Cards Accepted" label-for="creditCards">
        <credit-cards :value="venue.creditCards" v-model="venue.creditCards" @change="onChange" />
      </b-form-group>
    </div>
  </b-card>
</template>

<script>
import creditCards from '../../../components/CreditCards.vue';
import TelephoneInput from '../../../components/TelephoneInput.vue';

export default {
  components: {
    creditCards,
    TelephoneInput,
  },
  data() {
    return {
      venue: {
        scheduleUrl: '',
        ticketUrl: '',
        telephone: '',
        discounts: '',
        creditCards: [],
      },
      urlTest: /(http(s?)):\/\//i,
    };
  },
  props: ['value'],
  mounted() {
    this.venue = this.value;
  },
  methods: {
    onChange() {
      this.$emit('input', this.venue);
      this.$emit('change', this.venue);
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
  },
};
</script>

<style></style>
